export default __webpack_public_path__ + "static/media/logo06.94de1f70.svg";